import * as Sentry from '@sentry/angular-ivy';

interface TicketEventService {
    id?: string;
    SNAKE_CASE?: string;
    version?: string;
}

/**
 * Tags every ticket-flow Sentry event with `serviceId` (searchable) so a
 * specific service's ticket-creation attempts can be looked up after the
 * fact, e.g. when a client reports a missing Jira ticket.
 */
function withTicketScope(
    flow: string,
    service: TicketEventService,
    extra: Record<string, unknown>,
    run: () => void
) {
    Sentry.withScope((scope) => {
        scope.setTag('flow', flow);
        scope.setTag('serviceId', service?.id);
        scope.setContext('ticket', {
            serviceId: service?.id,
            serviceType: service?.SNAKE_CASE,
            serviceVersion: service?.version,
            ...extra,
        });
        run();
    });
}

export function reportTicketMessage(
    flow: string,
    service: TicketEventService,
    level: 'info' | 'warning',
    message: string,
    extra: Record<string, unknown> = {}
) {
    withTicketScope(flow, service, extra, () => Sentry.captureMessage(message, level));
}

export function reportTicketError(
    flow: string,
    service: TicketEventService,
    err: unknown,
    extra: Record<string, unknown> = {}
) {
    withTicketScope(flow, service, extra, () => Sentry.captureException(err));
}
